<template>
  <button
    v-if="labelCount > 1"
    type="button"
    :disabled="isDownloading"
    class="mb-4 inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-indigo-700 disabled:cursor-not-allowed disabled:bg-gray-400"
    @click="downloadAll"
  >
    <i
      class="fas mr-2"
      :class="isDownloading ? 'fa-spinner fa-spin' : 'fa-file-pdf'"
    ></i>
    {{
      isDownloading
        ? "Préparation du PDF..."
        : `Télécharger les ${labelCount} étiquettes`
    }}
  </button>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { downloadAllOrderLabels } from "@/api/orders";
import { useNotification } from "@/composables/useNotification";

const props = defineProps<{
  orderId: number;
  labelCount: number;
}>();

const isDownloading = ref(false);
const { error: showError } = useNotification();

const downloadAll = async () => {
  if (isDownloading.value) return;
  isDownloading.value = true;
  try {
    const blob = await downloadAllOrderLabels(props.orderId);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `etiquettes-commande-${props.orderId}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) {
    showError(
      error instanceof Error
        ? error.message
        : "Impossible de télécharger les étiquettes",
    );
  } finally {
    isDownloading.value = false;
  }
};
</script>
